let start = new Date()
start.setHours(0, 0, 0, 0)

export const isExpired = (date) => new Date(date) <= start
